<section>
  <button type="button" class="btn btn-back d-flex align-items-center py-5" [routerLink]="['/office-lease']"
    routerLinkActive="router-link-active">
    <img src="assets/icons/arrow-left.png"> <span class="mx-4">Back</span>
  </button>


  <div class="container-fluid px-4">
    <div class="container-card mb-4">

      <div class="row">
        <div class="col-12 col-md-12 col-lg-2 p-0">
          <div class="box-container-image">

            <div [ngSwitch]="true">
              <div *ngSwitchCase="itemLeaseDetail.pict === null || itemLeaseDetail.pict === undefined">
                <img src="assets/images/default-office-lease-detail.png" alt="Office Lease Detail">
              </div>
              <div *ngSwitchDefault>
                <img [src]="itemLeaseDetail.pict">
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-5 my-4 my-sm-4 my-lg-0">
          <div class="container">
            <h5 class="heading-1">{{ itemLeaseDetail.name }}</h5>
            <p class="text-muted">{{ itemLeaseDetail.address }}</p>

            <div class="card card-detail-address my-4 my-sm-4 my-md-0 my-lg-0">

              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <h5 class="section-title">Total Floor</h5>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <h5 class="section-count">{{ itemLeaseDetail.total_floor }}</h5>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <h5 class="section-title">Full Occupied</h5>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <h5 class="section-count">{{ itemLeaseDetail.full_occupied }}</h5>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <h5 class="section-title">Partially Occupied</h5>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <h5 class="section-count">{{ itemLeaseDetail.partial_occupied }}</h5>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <h5 class="section-title">Vacant Floor</h5>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <h5 class="section-count">{{ itemLeaseDetail.vacant }}</h5>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <h5 class="section-title">Total Occupancy (%)</h5>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <h5 class="section-count">{{ itemLeaseDetail.total_occupancy }}</h5>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="col-12 col-md-12 col-lg-5">

          <div class="card card-equal-height">
            <div class="card-header">
              <h5 class="heading-1">
                <img src="assets/icons/revenue-lease.png" alt=""> Revenue & SQM Available
              </h5>
            </div>

            <div class="card-body d-flex flex-column align-items-center">

              <div class="box-items-revenue my-1 align-items-center align-content-center"
                *ngFor="let item of itemLeaseDetailRO">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-start">
                    <h5 class="revenue-section-title">{{ item.name }}</h5>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6">
                    <div [ngSwitch]="true" class="d-flex justify-content-end">
                      <h5 *ngSwitchCase="item.name === 'SQM Available'" class="revenue-section-count">{{ item.value |
                        squareMeter }}</h5>
                      <h5 *ngSwitchDefault class="revenue-section-count">{{ item.value | rupiah }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="container-fluid py-4 px-4">
    <div class="container-card mb-4">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="heading-1">Building Floor</h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control search-input" placeholder="Type Tenant Name" [(ngModel)]="searchTerm"
              (keyup)="onSearch($event)">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center sortable-header" (click)="onSort('floor')">
                <span>Floor</span>
                <i [class]="getSortIcon('floor')" class="sort-icon"></i>
              </th>
              <th class="text-center">
                <span>Status</span>
              </th>
              <th class="text-center sortable-header" (click)="onSort('usedArea')">
                <span>Used Area</span>
                <i [class]="getSortIcon('usedArea')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header">
                <span>Tenant</span>
              </th>
              <th class="text-center sortable-header" (click)="onSort('sqmAvailable')">
                <span>SQM Available</span>
                <i [class]="getSortIcon('sqmAvailable')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('monthlyRevenue')">
                <span>Periodic Revenue</span>
                <i [class]="getSortIcon('monthlyRevenue')" class="sort-icon"></i>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="!isLoading && itemLease.length > 0">
            <tr *ngFor="let item of itemLease">
              <td class="text-center">
                <span (click)="openFloorDetailsModal(item)" style="cursor: pointer;">{{ item.floor }}</span>
              </td>
              <td class="d-flex justify-content-center align-content-center text-center">
                <div [ngSwitch]="item.occupancy_status">
                  <div *ngSwitchCase="'Fully Occupied'" class="badge-full-occupied">{{ item.occupancy_status }}</div>
                  <div *ngSwitchCase="'Partially Occupied'" class="badge-partially-occupied">{{ item.occupancy_status }}
                  </div>
                  <div *ngSwitchCase="'Vacant'" class="badge-vacant">{{ item.occupancy_status }}</div>
                  <div *ngSwitchDefault>{{ item.occupancy_status }}</div>
                </div>
              </td>
              <td class="text-center">{{ item.area_used }}%</td>
              <td class="tenant-cell">
                <div class="tenant-display">
                  <!-- Show first 2 tenants only -->
                  <span class="tenant-name">
                    <ng-container *ngIf="item.tenant && item.tenant.length > 0">
                      {{ item.tenant.length === 1 ? item.tenant[0] : (item.tenant[0] + (item.tenant.length > 1 ? ', ' +
                      item.tenant[1] : '')) }}

                      <!-- Show ellipsis if there are more than 2 tenants -->
                      <ng-container *ngIf="item.tenant.length > 2">...</ng-container>
                    </ng-container>
                  </span>

                  <!-- Show info icon only if there are tenants -->
                  <img *ngIf="item.tenant && item.tenant.length > 0" src="assets/icons/info-circle.png"
                    (click)="showTenantDetails(item.tenant, $event)" class="info-icon" alt="View all tenants">
                </div>
              </td>
              <td class="text-end">{{ item.sqm_available | squareMeter }}</td>
              <td class="text-end">
                <div [ngSwitch]="item.monthly_revenue == 0">
                  <div *ngSwitchCase="true">-</div>
                  <div *ngSwitchDefault> {{ item.monthly_revenue | rupiah }} </div>
                </div>

              </td>
            </tr>

          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="6" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6" *ngFor="let item of itemLease; let i = index">
              <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button">
                <div class="card-header card-sm-header">
                  <h5>Floor {{ item.floor }}</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-5">
                      <div class="card-sm-title mt-2">Status</div>
                      <div class="card-sm-title mt-2">Used Area</div>
                      <div class="card-sm-title mt-2">Tenant</div>
                      <div class="card-sm-title mt-2">SQM Available</div>
                      <div class="card-sm-title mt-2">Periodic Revenue</div>
                    </div>
                    <div class="col-7">
                      <div [ngSwitch]="item.occupancy_status" class="mt-2">
                        <div *ngSwitchCase="'Fully Occupied'" class="badge-full-occupied">{{ item.occupancy_status }}
                        </div>
                        <div *ngSwitchCase="'Partially Occupied'" class="badge-partially-occupied">{{
                          item.occupancy_status }}
                        </div>
                        <div *ngSwitchCase="'Vacant'" class="badge-vacant text-center">{{ item.occupancy_status }}</div>
                        <div *ngSwitchDefault>{{ item.occupancy_status }}</div>
                      </div>
                      <div class="card-sm-title mt-2">{{ item.area_used }}%</div>
                      <div class="card-sm-title mt-2">
                        <span class="tenant-name">
                          <ng-container *ngIf="item.tenant && item.tenant.length > 0">
                            <!-- {{ item.tenant.length > 0 ? item.tenant[0] : '' }} -->
                            {{ item.tenant[0] | limitText:11 }}

                            <!-- <ng-container *ngIf="item.tenant.length > 1">...</ng-container> -->
                          </ng-container>
                        </span>

                        <!-- Show info icon only if there are tenants -->
                        <img *ngIf="item.tenant && item.tenant.length > 0" src="assets/icons/info-circle.png"
                          (click)="showTenantDetails(item.tenant, $event)" class="info-icon" alt="View all tenants">
                      </div>
                      <div class="card-sm-title mt-2">{{ item.sqm_available | squareMeter }}</div>
                      <div [ngSwitch]="item.monthly_revenue == 0" class="mt-2" style="font-size: 12px;">
                        <div *ngSwitchCase="true">-</div>
                        <div *ngSwitchDefault> {{ item.monthly_revenue | rupiah }} </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
                  <div class="spinner-border text-success text-center" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start total-page-number">
          <h5 class="pageCount">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </h5>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>


<ng-template #floorDetailsModal let-modal>
  <div class="modal-body p-0">
    <div class="row g-0">
      <!-- Left side: Floor details panel with its own header -->
      <div class="col-md-5 p-0">
        <div class="p-4">
          <!-- Left side header -->
          <h5 class="modal-title fw-bold mb-4">Floor Details</h5>

          <!-- Floor details content -->
          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Floor</div>
            <div class="col-6 text-end left-modal-title">{{ floorDetails?.floor }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Occupy Status</div>
            <div class="col-6 col-6 text-center d-flex justify-content-end">
              <!-- <span class="badge badge-custom">{{ floorDetails?.occupancy_status }}</span> -->
              <div [ngSwitch]="floorDetails?.occupancy_status">
                <div *ngSwitchCase="'Fully Occupied'" class="badge-full-occupied">{{ floorDetails?.occupancy_status }}
                </div>
                <div *ngSwitchCase="'Partially Occupied'" class="badge-partially-occupied">{{
                  floorDetails?.occupancy_status }}
                </div>
                <div *ngSwitchCase="'Vacant'" class="badge-vacant">{{ floorDetails?.occupancy_status }}</div>
                <div *ngSwitchDefault>{{ floorDetails?.occupancy_status }}</div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Total Area</div>
            <div class="col-6 text-end left-modal-title">{{ floorDetails?.total_area | squareMeter }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Area Used</div>
            <div class="col-6 text-end left-modal-title">{{ floorDetails?.sqm_used | squareMeter }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Periodic Revenue</div>
            <div class="col-6 text-end left-modal-title">{{ floorDetails?.monthly_revenue ?? 0 | rupiah }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Periodic Rent Rate</div>
            <div class="col-6 text-end left-modal-title">{{ floorDetails?.rental_fee ?? 0 | rupiah }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Periodic Service Charge</div>
            <div class="col-6 text-end left-modal-title">{{ floorDetails?.service_charge ?? 0 | rupiah }}</div>
          </div>

          <div class="row mb-3">
            <div class="col-6 bold-modal-title">Total Tenant</div>
            <div class="col-6 text-end left-modal-title">{{ tenantCount }}</div>
          </div>

          <div class="mt-4">
            <div class="card" style="border: 1px solid #B6D1C1;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-6 text-available">Area Available</div>
                  <div class="col-6 text-end left-modal-title">{{ floorDetails?.sqm_available | squareMeter }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side: Office image with navigation and close button -->
      <div class="col-md-7 p-0 position-relative">
        <!-- Close button positioned in the image area -->
        <button type="button" class="btn-close modal-close-btn" aria-label="Close" (click)="modal.dismiss()"></button>

        <!-- Full-height image -->

        <!-- <div class="office-image-container">
          <img [src]="images[currentImageIndex]" class="modal-office-image-full" alt="Office Lease Detail">
        </div> -->

        <div [ngSwitch]="true">
          <div *ngSwitchCase="images.length === 0">
            <img src="assets/images/empty-building-floor.png" class="modal-office-image-none" alt="Office Lease Detail">
          </div>
          <div *ngSwitchDefault>
            <img [src]="images[currentImageIndex]" class="modal-office-image" alt="Office Space">
          </div>
        </div>

        <!-- Navigation arrows -->
        <button class="btn btn-light btn-sm nav-arrow nav-arrow-left" (click)="prevImage()"
          [disabled]="currentImageIndex === 0">
          <i class="ri-arrow-left-line text-white fa-lg"></i>
        </button>

        <button class="btn btn-light btn-sm nav-arrow nav-arrow-right" (click)="nextImage()"
          [disabled]="currentImageIndex === images.length - 1">
          <i class="ri-arrow-right-line text-white fa-lg"></i>
        </button>
      </div>
    </div>
  </div>
</ng-template>